import { useStateContext } from '@/context/StateContext';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Badge } from '@/components/ui/badge';
import { MapPin, ChevronDown } from 'lucide-react';

export const StateSelector = () => {
  const { currentState, states, selectState, loading } = useStateContext();

  if (loading) {
    return (
      <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-card border border-border">
        <MapPin className="w-4 h-4 text-muted-foreground" />
        <span className="text-sm text-muted-foreground">Loading...</span>
      </div>
    );
  }

  const currentStateData = states.find(s => s.state_code === currentState);

  return (
    <div className="flex items-center gap-2" data-testid="state-selector">
      <Select value={currentState} onValueChange={selectState}>
        <SelectTrigger 
          className="w-[180px] bg-card border-border hover:bg-accent"
          data-testid="state-selector-trigger"
        >
          <div className="flex items-center gap-2">
            <MapPin className="w-4 h-4 text-primary" />
            <SelectValue placeholder="Select State" />
          </div>
        </SelectTrigger>
        <SelectContent>
          {states.map((state) => (
            <SelectItem 
              key={state.state_code} 
              value={state.state_code}
              disabled={!state.enabled}
              data-testid={`state-option-${state.state_code}`}
            >
              <div className="flex items-center justify-between w-full gap-2">
                <span>{state.state_name}</span>
                {state.game_count > 0 && (
                  <Badge variant="secondary" className="text-xs">
                    {state.game_count} games
                  </Badge>
                )}
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {currentStateData?.game_count === 0 && currentState !== 'WA' && (
        <Badge variant="outline" className="text-xs text-amber-500 border-amber-500">
          No data yet
        </Badge>
      )}
    </div>
  );
};

export default StateSelector;
